import { render, staticRenderFns } from "./OtherSizes.vue?vue&type=template&id=0270f0d4&"
import script from "./OtherSizes.vue?vue&type=script&lang=js&"
export * from "./OtherSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports